import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import { CatalogGiftsContent } from "modules/Catalogs/CatalogGifts";

import React from "react";
import { useParams } from "react-router";

import { setTitle } from "utilities/helper/setTitle";

const CatalogGiftsPage: React.FC = () => {
  setTitle("Catalog Gift");
  const { catalogId } = useParams();

  return (
    <Auth>
      <Layout>
        <CatalogGiftsContent catalogId={catalogId} />
      </Layout>
    </Auth>
  );
};

export default CatalogGiftsPage;
